export default {
    // Header Section
    "discover_your": "మీ",
    "gemstones": "రత్నాలు",
    "healing_crystal_guidance": "వైద్య క్రిస్టల్ మార్గదర్శకత్వం",
    "gemstones_description": "మీ ప్రత్యేక జన్మ కుండలి ఆధారంగా వ్యక్తిగత రత్నాలు మరియు క్రిస్టల్ సిఫార్సులను పొందండి. వైద్యం, రక్షణ, శ్రేయస్సు మరియు ఆధ్యాత్మిక అభివృద్ధికి సరైన రాళ్లను గుర్తించండి — వాటిని ఎలా ఎంచుకోవాలి, ధరించాలి మరియు ప్రయోజనాలను గరిష్టంగా పొందడానికి నిపుణుల మార్గదర్శకత్వాన్ని పొందండి.",

    "gemstone_power": "మీకు అనుకూలమైన రత్నాలను సూచిస్తాం",
    "unlock_your": "మీ జన్మజాతక విశ్లేషణ ఆధారంగా, ",

    // Service Information
    "enter_details_for_gemstone_analysis": "రత్న విశ్లేషణ కోసం మీ వివరాలు నమోదు చేయండి",
    "complete_gemstone_analysis": "పూర్తి రత్న విశ్లేషణ",
    "service_price": "సేవా మూల్యం",
    "comprehensive_gemstone_analysis_note": "గ్రహ విశ్లేషణ మరియు ధరించే మార్గదర్శకత్వంతో వ్యక్తిగత రత్న సిఫార్సులు",

    // Form Fields
    "full_name": "పూర్తి పేరు",
    "enter_full_name": "మీ పూర్తి పేరు నమోదు చేయండి",
    "name_gemstone_resonance": "మీ పేరు కంపనలు రత్న అనుగుణ్యత మరియు అనుకూలతను నిర్ణయించడంలో సహాయపడతాయి",
    "email_address": "ఇమెయిల్ చిరునామా",
    "enter_email_address": "మీ ఇమెయిల్ చిరునామా నమోదు చేయండి",
    "phone_number": "ఫోన్ నంబర్",
    "enter_phone_number": "మీ ఫోన్ నంబర్ నమోదు చేయండి",
    "gender": "లింగం",
    "male": "పురుషుడు",
    "female": "స్త్రీ",
    "other": "ఇతర",
    "date_of_birth": "జన్మ తేదీ",
    "birth_date_planetary_gemstones": "గ్రహ ప్రభావాలు మరియు అనుకూల రత్నాలను నిర్ణయించడానికి అవసరం",
    "time_of_birth": "జన్మ సమయం",
    "exact_time_gemstone_selection": "ఖచ్చితమైన గ్రహ బల విశ్లేషణ కోసం ఖచ్చితమైన సమయం అవసరం",
    "place_of_birth": "జన్మ స్థలం",
    "place_of_birth_placeholder": "నగరం, రాష్ట్రం, దేశం",
    "location_affects_gemstone_energy": "స్థానం రత్న ఎంపికను ప్రభావితం చేసే గ్రహ స్థానాలను ప్రభావితం చేస్తుంది",
    "preferred_language": "ఇష్టపడే భాష",
    "english": "ఇంగ్లీష్",
    "hindi": "హిందీ",
    "telugu": "తెలుగు",
    "kannada": "కన్నడ",
    "language_note": "మీ రత్న గైడ్ ఎంచుకున్న భాషలో అందించబడుతుంది",

    // Core Gemstone Features
    "personalized_gemstone_recommendations": "వ్యక్తిగత రత్న సిఫార్సులు",
    "planetary_gemstone_analysis": "గ్రహ రత్న విశ్లేషణ",
    "healing_crystal_guidance": "వైద్య క్రిస్టల్ మార్గదర్శకత్వం",
    "wearing_methods_timing": "ధరించే పద్ధతులు & సమయం",
    "gemstone_care_instructions": "రత్న సంరక్షణ సూచనలు",
    "pdf_download": "సమగ్ర PDF గైడ్",

    "what_you_get": "మీ రత్న విశ్లేషణలో ఉన్నవి",
    "personalized_gemstone_guide": "వ్యక్తిగత రత్న గైడ్",
    "planetary_remedial_stones": "గ్రహ పరిహార రత్నాలు",
    "healing_crystal_recommendations": "వైద్య క్రిస్టల్ సిఫార్సులు",
    "wearing_activation_guidance": "ధరించే & సక్రియం చేసే మార్గదర్శకత్వం",

    // Actions & Buttons
    "pay_and_get_gemstone_guidance": "నా రత్న గైడ్ పొందండి",
    "processing_payment": "చెల్లింపు ప్రాసెస్ చేస్తున్నాము",
    "processing_request": "గైడ్ తయారు చేస్తున్నాము",

    // Payment & Success Messages
    "thank_you": "ధన్యవాదాలు",
    "payment_successful": "చెల్లింపు విజయవంతం!",
    "gemstone_analysis_processing": "మీ వ్యక్తిగత రత్న విశ్లేషణ మా నిపుణ రత్న శాస్త్రవేత్తలు మరియు జ్యోతిష్కులచే తయారు చేయబడుతోంది. మీరు వైద్య మరియు పరిహార రత్నాల కోసం వివరమైన సిఫార్సులను పొందుతారు.",
    "order_id": "ఆర్డర్ ID",
    "payment_id": "పేమెంట్ ID",
    "amount_paid": "చెల్లించిన మొత్తం",

    // Delivery Information
    "delivery_information": "డెలివరీ సమాచారం",
    "delivery_time": "గైడ్ డెలివరీ",
    "within_12_hours_delivery_note": "మీ వివరమైన రత్న గైడ్ 12 గంటలలోపు సిద్ధంగా ఉంటుంది",
    "whatsapp_notification": "వాట్సాప్ అప్‌డేట్లు",
    "whatsapp_delivery_note": "వాట్సాప్‌లో తక్షణ నోటిఫికేషన్లు పొందండి",
    "email_delivery": "ఇమెయిల్ డెలివరీ",
    "email_delivery_note": "పూర్తి గైడ్ డెలివర్ చేయబడుతుంది",

    // What You'll Receive
    "what_youll_receive": "మీ రత్న గైడ్ ప్యాకేజీ",
    "detailed_gemstone_report_pdf": "వివరమైన రత్న నివేదిక (PDF)",
    "personalized_stone_recommendations": "వ్యక్తిగత రాయి సిఫార్సులు",
    "planetary_remedial_guidance": "గ్రహ పరిహార మార్గదర్శకత్వం",
    "wearing_activation_methods": "ధరించే & సక్రియం చేసే పద్ధతులు",
    "gemstone_care_maintenance": "రత్న సంరక్షణ & నిర్వహణ",

    // Visual Content
    "sample_gemstone_analysis": "నమూనా రత్న విశ్లేషణ",
    "recommended_gemstone": "సిఫార్సు చేసిన రత్నం",
    "sample_gemstone_reading": "శని బలంకరణ మరియు జ్ఞాన పెంపుదల కోసం నీలమణి",
    "sample_gemstone_preview": "వైద్య లక్షణాలతో మీ వ్యక్తిగత రత్న సిఫార్సుల ప్రివ్యూ",
    "gemstone_categories": "రత్న వర్గాలు",

    // Gemstone Types
    "ruby": "కెంపు",
    "emerald": "పచ్చ",
    "sapphire": "నీలమణి",
    "diamond": "వజ్రం",
    "yellow_sapphire": "పుష్యరాగం",
    "coral": "పగడం",

    // Status & Processing
    "your_gemstone_analysis_status": "మీ రత్న విశ్లేషణ స్థితి",
    "processing_your_analysis": "మీ రత్న అవసరాలను విశ్లేషిస్తున్నాము",
    "analysis_processing_message": "మా నిపుణ రత్న శాస్త్రవేత్తలు వైద్యం, రక్షణ మరియు శ్రేయస్సు కోసం అత్యంత అనుకూలమైన రత్నాలను సిఫార్సు చేయడానికి మీ జన్మ కుండలిని అధ్యయనం చేస్తున్నారు.",
    "request_id": "విశ్లేషణ ID",
    "status": "స్థితి",
    "processing": "ప్రగతిలో",
    "pending": "వేచి ఉన్న",
    "email_notification_sent": "నిర్ధారణ ఇమెయిల్ పంపబడింది",
    "whatsapp_update_coming": "వాట్సాప్ అప్‌డేట్లు ప్రారంభించబడ్డాయి",
    "delivery_within_12_hours": "గైడ్ 12 గంటలలో సిద్ధం",

    // Support & Contact
    "contact_support": "రత్న మద్దతు సంప్రదించండి",
    "need_help": "మార్గదర్శకత్వం అవసరమా?",
    "contact_us_at": "మమ్మల్ని సంప్రదించండి",

    // Error Messages
    "please_fill_all_required_fields": "దయచేసి అన్ని అవసరమైన జన్మ వివరాలను పూర్తి చేయండి",
    "payment_failed": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "processing_failed": "విశ్లేషణ ప్రాసెసింగ్ విఫలమైంది. మా మద్దతు బృందాన్ని సంప్రదించండి.",

    // Planetary Gemstones
    "sun_gemstones": "సూర్య రత్నాలు",
    "moon_gemstones": "చంద్ర రత్నాలు",
    "mars_gemstones": "అంగారక రత్నాలు",
    "mercury_gemstones": "బుధ రత్నాలు",
    "jupiter_gemstones": "గురు రత్నాలు",
    "venus_gemstones": "శుక్ర రత్నాలు",
    "saturn_gemstones": "శని రత్నాలు",
    "rahu_gemstones": "రాహు రత్నాలు",
    "ketu_gemstones": "కేతు రత్నాలు",

    // Primary Gemstones
    "ruby_manik": "కెంపు (మాణిక్యం)",
    "pearl_moti": "ముత్యం (మోతి)",
    "coral_moonga": "ఎర్ర పగడం (మూంగా)",
    "emerald_panna": "పచ్చ (పన్న)",
    "yellow_sapphire_pukhraj": "పుష్యరాగం (పుఖ్రాజ్)",
    "diamond_heera": "వజ్రం (హీరా)",
    "blue_sapphire_neelam": "నీలమణి (నీలం)",
    "hessonite_gomed": "గోమేదకం (గోమేద్)",
    "cats_eye_lehsunia": "వైడూర్యం (లెహ్సునియా)",

    // Secondary Gemstones
    "garnet": "గార్నెట్",
    "moonstone": "చంద్రకాంతం",
    "carnelian": "కార్నెలియన్",
    "peridot": "పెరిడాట్",
    "citrine": "సిట్రిన్",
    "opal": "ఓపల్",
    "amethyst": "అమెథిస్ట్",
    "agate": "అగేట్",
    "onyx": "ఓనిక్స్",

    // Healing Crystals
    "rose_quartz": "రోజ్ క్వార్ట్జ్",
    "clear_quartz": "క్లియర్ క్వార్ట్జ్",
    "amethyst_crystal": "అమెథిస్ట్ క్రిస్టల్",
    "citrine_crystal": "సిట్రిన్ క్రిస్టల్",
    "black_tourmaline": "బ్లాక్ టూర్మలిన్",
    "green_aventurine": "గ్రీన్ అవెంచురిన్",
    "tigers_eye": "టైగర్స్ ఐ",
    "labradorite": "లాబ్రడోరైట్",
    "fluorite": "ఫ్లోరైట్",

    // Gemstone Properties
    "healing_properties": "వైద్య లక్షణాలు",
    "protective_properties": "రక్షణ లక్షణాలు",
    "prosperity_properties": "శ్రేయస్సు లక్షణాలు",
    "spiritual_properties": "ఆధ్యాత్మిక లక్షణాలు",
    "emotional_properties": "భావోద్వేగ వైద్య లక్షణాలు",
    "physical_properties": "శారీరక వైద్య లక్షణాలు",

    // Gemstone Selection Criteria
    "planetary_strength": "గ్రహ బల విశ్లేషణ",
    "weak_planets": "బలహీన గ్రహాల గుర్తింపు",
    "malefic_planets": "పాప గ్రహాల విశ్లేషణ",
    "benefic_enhancement": "శుభ గ్రహ వృద్ధి",
    "doshas_correction": "దోష పరిష్కారం",
    "yogas_strengthening": "యోగాల బలపరచుట",

    // Quality & Authenticity
    "gemstone_quality": "రత్న గుణవత్త మార్గదర్శకాలు",
    "authenticity_check": "ప్రామాణికత ధృవీకరణ",
    "certification_importance": "ధృవీకరణ ప్రాముఖ్యత",
    "natural_vs_synthetic": "సహజ vs కృత్రిమ రాళ్లు",
    "treatment_disclosure": "చికిత్స & మెరుగుదల వెల్లడింపు",
    "origin_significance": "మూలం & మూలాధారం ప్రాధాన్యత",

    // Wearing Guidelines
    "wearing_finger": "ధరించే వేలు మార్గదర్శకత్వం",
    "wearing_day": "శుభ ధరించే రోజు",
    "wearing_time": "అనుకూల ధరించే సమయం",
    "metal_selection": "సెట్టింగ్ కోసం లోహ ఎంపిక",
    "weight_calculation": "రత్న బరువు లెక్కింపు",
    "purification_ritual": "శుద్దీకరణ & సక్రియం చేసే కర్మ",

    // Gemstone Care
    "cleaning_methods": "శుభ్రపరిచే & నిర్వహణ పద్ధతులు",
    "storage_guidelines": "సరైన నిల్వ మార్గదర్శకాలు",
    "energizing_techniques": "తిరిగి శక్తివంతం చేసే పద్ధతులు",
    "avoid_damage": "నష్టం నివారణ చిట్కాలు",
    "periodic_cleansing": "కాలానుగుణ శుద్దీకరణ కర్మలు",
    "replacement_timing": "మార్పు & అప్‌గ్రేడ్ సమయం",

    // Benefits & Effects
    "career_benefits": "కెరీర్ & వ్యాపార ప్రయోజనాలు",
    "health_benefits": "ఆరోగ్యం & క్షేమ ప్రయోజనాలు",
    "relationship_benefits": "సంబంధాలు & ప్రేమ ప్రయోజనాలు",
    "financial_benefits": "ఆర్థిక & శ్రేయస్సు ప్రయోజనాలు",
    "spiritual_benefits": "ఆధ్యాత్మిక అభివృద్ధి ప్రయోజనాలు",
    "protection_benefits": "రక్షణ & భద్రత ప్రయోజనాలు",

    // Timing & Muhurat
    "auspicious_timing": "శుభ కొనుగోలు సమయం",
    "wearing_muhurat": "ధరించే ముహూర్తం లెక్కింపు",
    "activation_timing": "సక్రియం చేసే కర్మ సమయం",
    "eclipse_precautions": "గ్రహణ కాల జాగ్రత్తలు",
    "festival_significance": "పండుగ & ప్రత్యేక రోజుల ప్రాధాన్యత",
    "monthly_guidelines": "నెలవారీ ధరించే మార్గదర్శకాలు",

    // Combination Guidelines
    "gemstone_combinations": "ప్రయోజనకరమైన రత్న కలయికలు",
    "conflicting_stones": "వైరుధ్య రాయి కలయికలు",
    "layered_wearing": "పొరల వారీగా ధరించే మార్గదర్శకాలు",
    "rotation_schedule": "రత్న రొటేషన్ షెడ్యూల్",
    "seasonal_preferences": "కాలానుగుణ రత్న ప్రాధాన్యతలు",
    "occasion_selection": "సందర్భ ఆధారిత ఎంపిక",

    // Alternative Options
    "budget_alternatives": "బడ్జెట్-అనుకూల ప్రత్యామ్నాయాలు",
    "substitute_stones": "ప్రత్యామ్నాయ రాయి ఎంపికలు",
    "semi_precious_options": "అర్ధ-విలువైన ప్రత్యామ్నాయాలు",
    "synthetic_alternatives": "కృత్రిమ రాయి ప్రత్యామ్నాయాలు",
    "crystal_alternatives": "క్రిస్టల్ & ఖనిజ ప్రత్యామ్నాయాలు",
    "rudraksha_combinations": "రుద్రాక్ష కలయికలు",

    // Special Categories
    "bridal_gemstones": "వధువు రత్న ఎంపిక",
    "childrens_gemstones": "పిల్లల రత్న మార్గదర్శకాలు",
    "elderly_recommendations": "వృద్ధులకు ప్రత్యేక సిఫార్సులు",
    "professional_stones": "వృత్తిపరమైన & కెరీర్ రాళ్లు",
    "students_gemstones": "విద్యార్థి & అకడమిక్ రాళ్లు",
    "artists_stones": "సృజనాత్మక & కళాత్మక రాళ్లు",

    // Astrological Factors
    "ascendant_stones": "లగ్న ఆధారిత రాయి ఎంపిక",
    "moon_sign_stones": "చంద్ర రాశి రత్న మార్గదర్శకత్వం",
    "sun_sign_influence": "సూర్య రాశి ఎంపికపై ప్రభావం",
    "navamsa_considerations": "నవాంశ చార్ట్ పరిగణనలు",
    "dasha_period_stones": "దశా కాలం నిర్దిష్ట రాళ్లు",
    "transit_considerations": "ప్రస్తుత గ్రహ సంచార పరిగణనలు",

    // Consultation Features
    "expert_consultation": "నిపుణ రత్న శాస్త్రవేత్త సంప్రదింపు",
    "follow_up_guidance": "అనుసరణ మార్గదర్శకత్వం అందుబాటులో",
    "customization_options": "కస్టమైజేషన్ & వ్యక్తిగతీకరణ",
    "update_recommendations": "నవీకరించిన సిఫార్సులు",
    "progress_tracking": "ప్రయోజనాల పురోగతి ట్రాకింగ్",
    "adjustment_guidance": "సర్దుబాటు & చక్కదిద్దుట",

    // Regional Preferences
    "indian_gemstones": "భారతీయ మూల రత్నాలు",
    "burmese_stones": "బర్మీస్ మూల రాళ్లు",
    "ceylon_sapphires": "సిలోన్ నీలమణి ప్రత్యేకత",
    "kashmir_sapphires": "కాశ్మీర్ నీలమణి ప్రీమియం",
    "colombian_emeralds": "కొలంబియన్ పచ్చ ఉత్కృష్టత",
    "african_gemstones": "ఆఫ్రికన్ మూల రత్నాలు",

    // Modern Applications
    "technology_enhancement": "సాంకేతికత & డిజిటల్ జీవిత మెరుగుదల",
    "stress_relief": "ఆధునిక ఒత్తిడి ఉపశమన పరిష్కారాలు",
    "urban_living": "పట్టణ జీవన రత్న అవసరాలు",
    "travel_protection": "ప్రయాణం & యాత్ర రక్షణ",
    "workspace_harmony": "కార్యాలయ సామరస్య రాళ్లు",
    "social_confidence": "సామాజిక ఆత్మవిశ్వాసం పెంపుదల"
};
